import { PLATFORMS } from '../data/content';
import './Platforms.css';

export default function Platforms() {
  return (
    <section id="platforms" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Integrations & Channels</span>
        <h2 className="sec-title">Deploy everywhere your team works.</h2>
        <p className="sec-sub">
          Aiva bots are channel-agnostic. Deploy on web, mobile, collaboration tools,
          and enterprise systems — with a single unified bot engine underneath.
        </p>
        <div className="platforms__grid">
          {PLATFORMS.map(p => (
            <div key={p.name} className="platform-card">
              <span className="platform-card__icon">{p.icon}</span>
              <span className="platform-card__name">{p.name}</span>
            </div>
          ))}
        </div>
        <div className="platforms__note">
          Available across <strong>web widget, mobile apps, Microsoft Teams, WhatsApp, Slack,
          CRM, HRMS, ERP,</strong> and ticketing systems. Custom integrations available via REST API.
        </div>
      </div>
    </section>
  );
}
